<template>
  <div class="b-tree" v-loading="loading">
    <el-input v-if="filter" class="filter" size="small" placeholder="输入关键字进行过滤" v-model="context" />
    <el-tree ref="bTree" :accordion="accordion" :show-checkbox="showCheckbox" :check-strictly="checkStrictly" :node-key="nodeKey" :data="data" :props="config" :default-expand-all="defaultExpandAll"
      :expand-on-click-node="expandOnClickNode" :check-on-click-node="checkOnClickNode" :auto-expand-parent="autoExpandParent" @node-click="nodeClick" @check="check"
      :default-expanded-keys="checkedKeys" :icon-class="iconClass" :draggable="draggable" @allow-drag="drag" @allow-drop="drop">
      <template slot-scope="{node, data}">
        <slot :node="node" :data="data" />
      </template>
    </el-tree>
  </div>
</template>

<script>
export default {
  name: 'Btree',
  props: {
    loading: { type: Boolean, default: () => false },
    accordion: { type: Boolean, default: () => false },
    filter: { type: Boolean, default: () => true },
    showCheckbox: { type: Boolean, default: () => true },
    checkStrictly: { type: Boolean, default: () => false },
    data: { type: Array, default: () => [] },
    nodeKey: { type: String, default: () => 'id' },
    horizontal: { type: Boolean, default: () => false },
    defaultExpandAll: { type: Boolean, default: () => true },
    expandOnClickNode: { type: Boolean, default: () => true },
    checkOnClickNode: { type: Boolean, default: () => false },
    autoExpandParent: { type: Boolean, default: () => true },
    defaultCheckedKeys: { type: Array, default: () => [] },
    defaultSelectedRow: { type: Object, default: () => { } },
    iconClass: { type: String, default: () => '' },
    draggable: { type: Boolean, default: () => false },
  },
  data() {
    return {
      config: {
        children: 'children',
        label: 'name'
      },
      halfCheckedKeys: [],
      checkedKeys: [],
      selectedRow: {},
      context: '',
    }
  },
  watch: {
    data() {
      this.create();
    },
    defaultCheckedKeys() {
      this.create();
    },
    context(value) {
      this.$refs['bTree'].filter(value);
    },
  },
  mounted() {
    this.create();
  },
  updated() {
    this.update();
  },
  methods: {
    search(value, data) {
      if (!value) return true;
      return data[this.labelKey].indexOf(value) != -1;
    },
    create() {
      this.checkedKeys = this.defaultCheckedKeys.filter(a => a != 0);
      this.$nextTick(() => {
        for (let a in this.checkedKeys) {
          this.$refs['bTree'].setChecked(this.checkedKeys[a], true, false);
        }
      });
    },
    update() {
      if (this.horizontal) {
        const lastLevelLeaf = document.getElementsByClassName('last-leaf');
        if (lastLevelLeaf) {
          for (let a = 0; a < lastLevelLeaf.length; a++) {
            lastLevelLeaf[a].parentElement.parentElement.parentElement.className = 'last-rows';
            lastLevelLeaf[a].parentElement.parentElement.style.display = 'inline-block';
          }
        }
      }
    },
    check() {
      this.checkedRows = this.$refs['bTree'].getCheckedNodes();
      this.checkedKeys = this.$refs['bTree'].getCheckedKeys();
      this.halfCheckedKeys = this.$refs['bTree'].getHalfCheckedKeys();
      this.$emit('check', [...this.checkedKeys, ...this.halfCheckedKeys]);
      this.$emit('choose', [...this.checkedKeys, ...this.halfCheckedKeys]);
    },
    nodeClick(e) {
      this.selectedRow = e;
      this.$emit('click', this.selectedRow);
      this.$emit('select', this.selectedRow);
    },
    drag(node) {
      this.$emit('drag', node);
    },
    drop(draggingNode, dropNode, type) {
      this.$emit('drop', { draggingNode, dropNode, type });
    },
  },
}
</script>

<style scoped>
@import "index.css";
</style>